import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";

class ItemBrandActive extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  Submit = () => {
    let value = this.props.ItemMasterActiveActvDtls;
    console.log("selecteditem", this.props.ItemMasterActiveActvDtls);
    this.props.ItemBrandInActive(value);
    this.props.handleClose();
    this.props.resetPage();
  };

  render() {
    const data =
      this.props.ItemMasterActiveActvDtls &&
      this.props.ItemMasterActiveActvDtls.item
        ? this.props.ItemMasterActiveActvDtls &&
          this.props.ItemMasterActiveActvDtls.item
        : null;
    console.log("selecteditem", this.props.ItemMasterActiveActvDtls);
    console.log("data", data);
    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="md"
            backdrop="static"
            centered={true}
            // className="modal-backdrop fade show"
          >
            {data !== null && data.disabled === true ? (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>
                      Do you want the brand and associated products back to
                      active status?
                    </b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            ) : (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>
                      Do you want to disable the brand and the products
                      associated?
                    </b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "30px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

export default ItemBrandActive;
